import React, { useState } from "react";
import AvatarIcon from "../../assets/images/Collective Talent Interface.svg";
import { Card } from "../../components/Card";
import { Button, Typography, Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

function AiavatarLanding() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    return (
        <Container style={{ padding: 0, width: "100%" }}>
            <Typography variant="featureAccent" gutterBottom>
                AI Avatar
            </Typography>

            <Card>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "80vh",
                        gap: 4,
                        textAlign: "center",
                    }}
                >
                    <Box
                        component="img"
                        src={AvatarIcon}
                        alt="Newsletter Icon"
                        sx={{
                            height: "10rem",
                            width: "10rem",
                        }}
                    />
                    <Typography variant="h6" color="textPrimary">
                        No AI Avatar Created yet{" "}
                    </Typography>
                    <Typography
                        variant="body1"
                        color="textSecondary"
                        sx={{
                            maxWidth: "60%",
                            margin: "0 auto",
                        }}
                    >
                        It looks like you have not created any AI avatar yet.
                        Start creating avatars and created different avatars
                        through AI commands. Its simple and easy.
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => navigate("create")}
                        sx={{
                            textTransform: "none",
                        }}
                    >
                        + Create New Avatar
                    </Button>

                    {/* <Button variant="contained" onClick={() => setOpen(true)}>
                    + Clone New Sound
                </Button> */}
                </Box>
            </Card>
        </Container>
    );
}

export default AiavatarLanding;
